import styled from '@emotion/styled';
import { css } from '@emotion/react';
import DropdownV3 from '@zola/zola-ui/src/components/Form/dropdownV3';
import { ListBoxContainer } from '@zola/zola-ui/src/components/Form/common/DropdownListBox/DropdownListBox.styles';
import { SearchInputAndCloseContainer } from 'components/nav/Search/SearchContainer/SearchContainer.styles';
import { COLORS3, FONT, SPACING } from '@zola/zola-ui/src/styles/emotion';

type UtilityBarWrapperProps = {
  hideContentOnScroll: boolean;
  showSecondaryNav: boolean;
};
export const UtilityBarWrapper = styled.div<UtilityBarWrapperProps>`
  display: flex;
  align-items: center;
  transition: height 0.3s linear;
  ${({ hideContentOnScroll, showSecondaryNav }) =>
    hideContentOnScroll && showSecondaryNav
      ? css`
          justify-content: flex-end;
          grid-column: 2;
        `
      : css`
          justify-content: space-between;
          grid-column: 1;
        `}
  ${({ hideContentOnScroll, showSecondaryNav }) => {
    if (hideContentOnScroll) {
      return css`
        height: 50px;
        padding: ${SPACING.XXS} ${SPACING.LG};
      `;
    }
    if (showSecondaryNav) {
      return css`
        height: 60px;
        padding: ${SPACING.S16} ${SPACING.LG} 0;
      `;
    }
    return css`
      height: 76px;
      padding: ${SPACING.S16} ${SPACING.LG};
    `;
  }}
  ${SearchInputAndCloseContainer} {
    background: none;
  }
`;

type PageTitleProps = {
  hideContentOnScroll: boolean;
  showSecondaryNav: boolean;
};
export const PageTitle = styled.h2<PageTitleProps>`
  ${({ hideContentOnScroll }) =>
    FONT.textSizeCompact(hideContentOnScroll ? FONT.SIZE.LARGE : FONT.SIZE.LARGER)}
  font-weight: ${FONT.WEIGHT.SEMI_BOLD};
  display: ${({ hideContentOnScroll, showSecondaryNav }) =>
    hideContentOnScroll && showSecondaryNav ? 'none' : 'block'};
  margin: 0;
  transition: font 0.3s linear; 
`;

export const UtilityBarRight = styled.div`
  display: flex;
  padding-top: ${SPACING.XS};
  position: relative;
`;

export const IconsContainer = styled.div`
  display: flex;
  padding: 0 ${SPACING.XS} ${SPACING.XS} ${SPACING.S16};
  .icon-link {
    position: relative;
    display: flex;
    padding: ${SPACING.SM};
    border-radius: 50%;
    &:hover,
    &.icon-link--selected {
      background-color: ${COLORS3.BLACK_005};
      cursor: pointer;
    }
    .badge {
      position: absolute;
      top: 2px;
      right: 2px;
      min-width: ${SPACING.SM};
      background-color: ${COLORS3.ROSE_100};
      border-radius: ${SPACING.SM};
      color: ${COLORS3.WHITE_100};
      font-size: ${FONT.SIZE.EXTRA_SMALL};
      font-weight: ${FONT.WEIGHT.BOLD};
      line-height: 1;
      padding: 3px 7px;
      text-align: center;
      vertical-align: middle;
      white-space: nowrap;
    }
  }
`;

export const StyledDropdownV3 = styled(DropdownV3)`
  ${ListBoxContainer} {
    max-height: fit-content;
  }
`;

const sharedCircleStyles = css`
  height: 44px;
  width: 44px;
  max-width: 44px;
  border-radius: 50%;
`;

export const ProfileImgCircle = styled.img<{ expanded: boolean }>`
  ${sharedCircleStyles};
  object-fit: cover;
  opacity: ${({ expanded }) => (expanded ? 0.75 : null)};
  &:hover {
    opacity: 0.75;
  }
`;

export const ProfileCircle = styled.div<{ expanded: boolean }>`
  ${sharedCircleStyles};
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${COLORS3.BLACK_030};
  font-size: ${FONT.SIZE.SMALLER};
  font-weight: ${FONT.WEIGHT.SEMI_BOLD};
  background-color: ${({ expanded }) => (expanded ? COLORS3.BLACK_005 : null)};
  &:hover {
    background-color: ${COLORS3.BLACK_005};
  }
`;
